import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';

import IconDef from '@/assets/svg/LinkArrow';

export const Nav = styled(motion.nav).attrs(({ $isOpen }) => ({
  animate: {
    left: $isOpen ? '0%' : '100%',
    opacity: $isOpen ? 1 : 0,
  },
  transition: { duration: $isOpen ? 0.3 : 0.05 },
  initial: false,
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  inset: 70px 0;
  z-index: 99;
  overflow: auto;
  @media (max-width: 991px) {
    inset: 60px 0;
  }
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  width: 100%;
  padding: 0 20px;
  @media (max-width: 991px) {
    padding: 0 10px;
  }
`;

export const LinkWrap = styled.div`
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 2px;
  align-items: center;
  width: 100%;
  @media (max-width: 1472px) {
    grid-template-columns: 1fr 1fr 1fr auto;
  }
  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const linkStyle = ({ $isActive }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 63px;
  width: 100%;
  border-radius: 31.5px;
  background-color: ${$isActive ? 'var(--color-black)' : 'rgba(152, 152, 152, 0.32)'};
  font: var(--font-33);
  color: ${$isActive ? 'var(--color-white)' : 'var(--color-black)'};
  text-decoration: none;
  text-transform: uppercase;
  &:active {
    background-color: var(--color-black);
    color: var(--color-white);
  }
  @media (hover) {
    &:hover {
      background-color: var(--color-black);
      color: var(--color-white);
    }
  }
`;

export const NavLink = styled(Link)`
  ${linkStyle}
`;

export const BookingButton = styled.button`
  ${linkStyle}
  position: relative;
  min-width: 0;
  padding: 0 12px;
  cursor: pointer;
  @media (min-width: 992px) {
    width: auto;
    padding: 0 63px 0 20px;
  }
  @media (max-width: 409px) {
    padding: 0 12px;
  }
`;

export const Label = styled.span`
  width: 100%;
  text-align: center;
  white-space: nowrap;
  @media (min-width: 992px) {
    width: auto;
  }
`;

export const Icon = styled(IconDef)`
  position: absolute;
  top: 50%;
  right: 8px;
  width: 47px;
  height: 47px;
  transform: translateY(-50%);
  ${BookingButton}:active>&>circle {
    fill: var(--color-greyDE);
  }
  ${BookingButton}:active>&>path {
    stroke: var(--color-black);
  }
  @media (max-width: 409px) {
    display: none;
  }
  @media (hover) {
    ${BookingButton}:hover>&>circle {
      fill: var(--color-greyDE);
    }
    ${BookingButton}:hover>&>path {
      stroke: var(--color-black);
    }
  }
`;

export const CloseButton = styled.button`
  flex: 0 0 auto;
  display: none;
  justify-content: center;
  align-items: center;
  height: 63px;
  width: 100%;
  border-radius: 31.5px;
  background-color: rgba(152, 152, 152, 0.32);
  font: var(--font-33);
  color: var(--color-black);
  text-transform: uppercase;
  &:active {
    background-color: var(--color-black);
    color: var(--color-white);
  }
  @media (hover) {
    &:hover {
      background-color: var(--color-black);
      color: var(--color-white);
    }
  }
  @media (max-width: 991px) {
    display: flex;
  }
`;
